import type { InputHTMLAttributes } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
}

export const Input = ({ label, className = '', ...props }: InputProps) => {
  return (
    <div>
      {label && (
        <label className="block text-[14px] font-[600] text-foreground mb-1">{label}</label>
      )}
      <input
        {...props}
        className={`w-full  px-3 border border-[#D9D9D9] bg-muted text-foreground rounded-[10px] h-[30px] text-[14px]  focus:outline-none focus:ring-blue-500 ${className}`}
      />
    </div>
  )
}